// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Slider_sliderContainer__sPcIl","slideItem":"Slider_slideItem__KxAG1","sliderImage":"Slider_sliderImage__a1F4m"};